import { RawUserInfo } from "./RawUserInfo";
import { AuthApi } from "./AuthApi";
import { Credentials } from "./Credentials";
import { UserLocalStorage } from "./UserLocalStorage";


export interface IAuthService {
    IsAuthorized: boolean;
    UserInfo: RawUserInfo | undefined;
    TryLogin(password: string): Promise<boolean>;
    Logout(): void;
    Set(user: RawUserInfo): void;
    TryLoginFromLocalStorage(): void;
}

export class AuthService implements IAuthService
{
    private user?: RawUserInfo;

    constructor(
        private _api: AuthApi,
        private _storage: UserLocalStorage)
    { }

    public get IsAuthorized(): boolean
    {
        return !!this.user?.User?.Id && this.user?.User?.Id != "";
    }

    public get UserInfo(): RawUserInfo | undefined
    {
        return this.user;
    }

    public async TryLogin(password: string): Promise<boolean>
    {
        const credentials = new Credentials(password);

        const result = await this._api.Login(credentials);
        const user = result.UserInfo;

        if (result.IsLoginSuccess && user)
        {
            this._storage.Save(user);
            this.user = user;
        }

        return result.IsLoginSuccess;
    }
    
    public Logout(): void
    {
        this.user = undefined;
        this._storage.Delete();
    }

    public Set(user): void
    {
        if (user)
        {
            this.user = user;
        }
    }

    public TryLoginFromLocalStorage(): void
    {
        if (this._storage.IsUserAvailable)
        {
            this.Set(this._storage.User);
        }
    }
}
